export default __webpack_public_path__ + "static/media/logo.78a1db6b.png";